.label {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  text-align: right;
  max-width: 100px;
}
